export default {
  app: {
    title: 'Bookshop Cafe Staff Login',
    loadingApp: 'Loading app...',
    loggedOut: 'Logged out successfully',
  },
  language: {
    en: 'EN',
    pt: 'PT',
    label: 'Language',
  },
  roles: {
    SUPERADMIN: '0 Superadmin',
    ADMIN: '1 Admin',
    MANAGER: '2 Manager',
    USER: '3 User',
  },
  menus: {
    app: 'App',
    scenario: 'Scenario',
    profile: 'Profile',
    logout: 'Logout',
    version: 'Version',
    darkMode: 'Dark mode',
    products: 'Products',
    productCategories: 'Product Categories',
    manageUsers: 'Manage Users',
    new: 'New',
    load: 'Load',
    loadRecent: 'Load Recent',
    noRecentScenarios: 'No recent scenarios',
    edit: 'Edit',
    duplicate: 'Duplicate',
    saveScenarioBaseState: 'Save Scenario Base State',
    reset: 'Reset',
    archiveScenario: 'Archive Scenario',
    archivedScenarios: 'Archived Scenarios',
    deleteScenario: 'Delete Scenario',
  },
  header: {
    scenario: 'Scenario:',
    untitledScenario: 'Untitled Scenario',
    hello: 'Hello',
  },
  search: {
    placeholder: 'Search tables, guests, or products...',
    button: 'Search',
    clear: 'Clear search',
    resultsTitle: 'Search Results',
    person: 'Person',
    noMatches: 'No matching tables found.',
  },
  scenario: {
    loadTitle: 'Load Scenario',
    empty: 'No saved scenarios.',
    loadSuccess: 'Scenario loaded successfully',
    archivedTitle: 'Archived Scenarios',
    archivedDescription: 'Click a scenario to restore and load it.',
    archivedEmpty: 'No archived scenarios.',
    restore: 'Restore',
    newTitle: 'New Scenario',
    duplicateTitle: 'Duplicate Scenario',
    editTitle: 'Edit Scenario',
    createButton: 'Create Scenario',
    duplicateButton: 'Duplicate Scenario',
    saveButton: 'Save Changes',
    name: 'Scenario Name',
    columns: 'Columns',
    rows: 'Rows',
    setDefault: 'Set as default scenario',
    showPrices: 'Show prices in orders',
    itemizePrintItems: 'Itemize items when printing orders',
    note: 'Changing rows or columns updates the working grid immediately. Existing tables stay in place.',
    close: 'Close',
    saveSuccess: 'Scenario saved successfully',
    createSuccess: 'Scenario created successfully',
    duplicateSuccess: 'Scenario duplicated successfully',
    createError: 'Could not create scenario.',
    duplicateError: 'Could not duplicate scenario.',
    updateSuccess: 'Scenario updated successfully',
    deleteSuccess: 'Scenario deleted successfully',
    archiveSuccess: 'Scenario archived successfully',
    restoreSuccess: 'Scenario restored successfully',
    resetSuccess: 'Scenario reset',
    resetError: 'Could not reset the scenario.',
    baseStateSaveSuccess: 'Scenario base state saved successfully',
    baseStateSaveError: 'Could not save the scenario base state.',
    baseStateMissingError: 'No saved base state exists for this scenario yet.',
    setDefaultSuccess: 'Default scenario set to "{name}"',
    reservedName: 'This scenario name is reserved. Please choose another name.',
    requireName: 'Please enter a scenario name before saving.',
    requireNameCreate: 'Scenario name is required.',
    notFound: 'Scenario not found',
    notFoundLocal: 'Scenario not found locally.',
    noRecentFound: 'No recent scenario found.',
    loadRecentError: 'Unable to load recent scenario.',
    loadError: 'Could not parse saved scenario',
    saveError: 'Could not save scenario',
    deleteError: 'Could not delete scenario',
    updateError: 'Could not update scenario.',
    archiveError: 'Could not archive scenario.',
    restoreError: 'Could not restore scenario.',
    setDefaultError: 'Unable to set default scenario.',
    confirmDelete: 'Delete this scenario?',
  },
  table: {
    tables: 'Tables',
    addTable: 'Add Table',
    addWall: 'Add Wall',
    delete: 'Delete',
    undo: 'Undo',
    redo: 'Redo',
    tableColor: 'Table color',
    wallColor: 'Wall color',
    editTitle: 'Edit Table',
    autosaveNote: 'Changes save automatically. Use Done when you\'re finished.',
    printOrder: 'Print Order',
    itemizePrint: 'Itemize items',
    itemizePrintHint: 'Change this option in Edit Scenario.',
    done: 'Done',
    close: 'Close',
    closeAria: 'Close',
    name: 'Name',
    person: 'Person',
    defaultColor: 'Default',
    products: 'Products',
    product: 'Product',
    productName: 'Product name',
    productNote: 'Notes',
    total: 'Total',
    totalNoPricesHint: 'products without value count as €0.00',
    addProductNote: 'Add Notes',
    quantityShort: 'Qty',
    addProduct: 'Add product',
    pasteProducts: 'Paste products',
    copyProducts: 'Copy products',
    removeAllProducts: 'Remove all products',
    tableNameRequired: 'Table name cannot be empty',
    updated: 'Table updated',
    noProductsToCopy: 'No products to copy',
    productsCopied: 'Products copied',
    productsPasted: 'Products pasted',
    noValidProductsToPaste: 'No valid products to paste',
    noProductsToPrint: 'No products to print',
    orderTitle: 'Order',
    orderFor: 'Order for {name}',
    dragToReorder: 'Drag to reorder',
    handling: 'On it',
    delivered: 'Delivered',
    paid: 'Paid',
    increaseQuantity: 'Increase quantity',
    decreaseQuantity: 'Decrease quantity',
    addedHistory: 'Added table {name}',
    editedHistory: 'Edited table {name}',
    deletedHistory: 'Deleted table {name}',
    reorderedHistory: 'Reordered tables',
    resetHistory: 'Reset scenario',
    initialHistory: 'Initial state',
    readonly: 'Read-only',
  },
  modal: {
    closeManageUsers: 'Close manage users modal',
    close: 'Close',
  },
  confirm: {
    deleteTitle: 'Confirm deletion',
    delete: 'Delete',
    cancel: 'Cancel',
    deleteScenarioBody: 'Are you sure you want to delete scenario "{name}"?',
    deleteUserBody: 'Are you sure you want to delete user "{name}"?',
    deleteProductBody: 'Are you sure you want to delete product "{name}"?',
    deleteCategoryBody: 'Are you sure you want to delete category "{name}"?',
  },
  profile: {
    title: 'Profile',
    email: 'Email',
    displayName: 'Display Name',
    changePassword: 'Change password',
    changePin: 'Change PIN',
    cancelPasswordChange: 'Cancel password change',
    cancelPinChange: 'Cancel PIN change',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    newPin: 'New PIN',
    confirmNewPin: 'Confirm New PIN',
    save: 'Save Changes',
    saving: 'Saving...',
    close: 'Close',
    updated: 'Profile updated successfully',
    updateError: 'Unable to update profile.',
    requireDisplayName: 'Display name is required.',
    requireEmail: 'Email is required.',
    requireCurrentPassword: 'Current password is required.',
    requireNewPassword: 'New password is required.',
    requireNewPin: 'New PIN is required.',
    minPassword: 'New password must be at least 8 characters.',
    passwordMismatch: 'New password confirmation does not match.',
    invalidPin: 'PIN must be 4 to 6 digits.',
    pinMismatch: 'PIN confirmation does not match.',
  },
  users: {
    title: 'Manage Users',
    loading: 'Loading users...',
    empty: 'No users available.',
    addUser: '+ Add User',
    editUser: 'Edit User',
    createUser: 'Create User',
    email: 'Email',
    displayName: 'Display Name',
    password: 'Password',
    newPasswordOptional: 'New Password (optional)',
    pin: 'PIN',
    newPinOptional: 'New PIN (optional)',
    active: 'Active',
    inactive: 'Inactive',
    role: 'Role',
    close: 'Close',
    saveChanges: 'Save Changes',
    createButton: 'Create User',
    deleteButton: 'Delete User',
    saving: 'Saving...',
    deleting: 'Deleting...',
    updated: 'User updated successfully',
    created: 'User created successfully',
    deleted: 'User deleted successfully',
    reLoginInfo: 'Your current session may need a re-login to reflect role changes.',
    loadError: 'Unable to load users.',
    saveError: 'Unable to save user.',
    deleteError: 'Unable to delete user.',
    requireFields: 'Email and display name are required.',
    requirePassword: 'Password is required for new users.',
    requirePin: 'PIN is required for new users.',
    addUserAria: 'Add user',
  },
  products: {
    title: 'Manage Products',
    loading: 'Loading products...',
    empty: 'No products available.',
    addProduct: '+ Add Product',
    addProductAria: 'Add product',
    editProduct: 'Edit Product',
    createProduct: 'Create Product',
    editingModeTitle: 'Editing existing product',
    creatingModeTitle: 'Creating new product',
    switchToCreate: 'New product',
    editingHint: 'To create a new product, click "New product".',
    id: 'Product ID',
    category: 'Category',
    name: 'Product Name',
    value: 'Value (EUR)',
    valueShort: 'EUR {value}',
    valuePlaceholder: 'Optional',
    noCategory: 'No category',
    noCategoriesAvailable: 'No categories available',
    uncategorized: 'Uncategorized',
    active: 'Active',
    inactive: 'Inactive',
    close: 'Close',
    saveChanges: 'Save Changes',
    createButton: 'Create Product',
    deleteButton: 'Delete Product',
    saving: 'Saving...',
    deleting: 'Deleting...',
    created: 'Product created successfully',
    updated: 'Product updated successfully',
    deleted: 'Product deleted successfully',
    loadError: 'Unable to load products.',
    requireId: 'Product ID is required.',
    requireCategory: 'Product category is required.',
    requireValidValue: 'Product value must be a valid non-negative number.',
    saveError: 'Unable to save product.',
    deleteError: 'Unable to delete product.',
    requireName: 'Product name is required.',
  },
  productCategories: {
    title: 'Manage Product Categories',
    loading: 'Loading categories...',
    empty: 'No categories available.',
    addCategory: '+ Add Category',
    addCategoryAria: 'Add category',
    editCategory: 'Edit Category',
    createCategory: 'Create Category',
    editingModeTitle: 'Editing existing category',
    creatingModeTitle: 'Creating new category',
    switchToCreate: 'New category',
    editingHint: 'To create a new category, click "New category".',
    name: 'Category Name',
    internalId: 'Category Internal ID',
    internalIdPlaceholder: 'E.g. swt',
    internalIdHint: 'Used to suggest product IDs automatically.',
    noInternalId: 'No internal ID',
    active: 'Active',
    inactive: 'Inactive',
    close: 'Close',
    saveChanges: 'Save Changes',
    createButton: 'Create Category',
    deleteButton: 'Delete Category',
    saving: 'Saving...',
    deleting: 'Deleting...',
    created: 'Category created successfully',
    updated: 'Category updated successfully',
    deleted: 'Category deleted successfully',
    loadError: 'Unable to load categories.',
    saveError: 'Unable to save category.',
    deleteError: 'Unable to delete category.',
    requireName: 'Category name is required.',
    requireInternalId: 'Category internal ID is required.',
    invalidInternalId: 'Category internal ID may only contain lowercase letters, numbers, and underscores.',
  },
  login: {
    introOnline: 'Sign in to access the POS.',
    backendUnavailable: 'The server is unavailable right now. Please check the connection and try again.',
    email: 'Email',
    user: 'User',
    password: 'Password',
    signIn: 'Sign in',
    signingIn: 'Signing in...',
    pinTitle: 'PIN login',
    pinDescription: 'Enter your PIN to unlock the POS quickly.',
    pin: 'PIN',
    usePin: 'Use PIN',
    pinSignIn: 'Sign in with PIN',
    pinEmailRequired: 'Enter the email first to use PIN login.',
    pinRequired: 'PIN is required.',
    noUsersAvailable: 'No users available',
    invalidCredentials: 'Login failed. Please check the selected user and password.',
    expired: 'Your previous session expired. Please sign in again.',
    error: 'Unable to log in',
  },
  passwordReset: {
    forgotPassword: 'Forgot password?',
    requestTitle: 'Recover password',
    requestDescription: 'Enter the user email and we will send a reset link if that account is active.',
    email: 'Email',
    cancel: 'Cancel',
    sendLink: 'Send reset link',
    sending: 'Sending...',
    requestSuccess: 'If the account exists, a password reset email has been sent.',
    requestError: 'Unable to send password reset email right now.',
    requireEmail: 'Email is required.',
    validatingTitle: 'Checking reset link',
    validatingBody: 'We are validating your password reset link.',
    resetTitle: 'Set a new password',
    resetDescription: 'Enter your new password below.',
    resetDescriptionNamed: 'Enter a new password for {name}.',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    resetButton: 'Reset password',
    resetting: 'Resetting...',
    resetSuccess: 'Password updated successfully. You can now sign in.',
    resetError: 'Unable to reset password.',
    requirePassword: 'New password is required.',
    minPassword: 'New password must be at least 8 characters.',
    passwordMismatch: 'Password confirmation does not match.',
    invalidTitle: 'Invalid reset link',
    invalidBody: 'This password reset link is invalid or no longer available.',
    expiredBody: 'This password reset link has expired. Request a new one from the login screen.',
    usedTitle: 'Password already reset',
    usedBody: 'This reset link has already been used. You can sign in with the new password or request another link.',
    invalidToken: 'Reset link is invalid.',
    backToLogin: 'Back to login',
  },
  passwordInput: {
    show: 'Show secret',
    hide: 'Hide secret',
  },
  auth: {
    sensitiveTitle: 'Password required',
    sensitiveDescription: 'Enter your password to access this protected area.',
    sensitivePassword: 'Password',
    continue: 'Continue',
    cancel: 'Cancel',
  },
  status: {
    online: 'Online',
    syncing: 'Syncing',
    waitingForLock: 'Waiting for edit lock',
    conflictDetected: 'Conflict detected',
    syncFailed: 'Sync failed',
    reloginRequired: 'Re-login required',
    conflictChanges: '{count} conflicting change(s)',
    pendingChanges: '{count} pending change(s)',
    noPendingChanges: 'No pending changes',
    lockedWillRetry: 'Your local changes are safe and will sync once this scenario becomes editable again.',
    syncNow: 'Sync now',
    useCloudVersion: 'Use cloud version',
    saveMineAsCopy: 'Save mine as copy',
    replaceCloudWithMine: 'Replace cloud with mine',
    loadLatest: 'Use cloud version',
    keepAsCopy: 'Save mine as copy',
    moreInfo: 'More information',
    loadLatestHelp: 'Discard your conflicting local scenario changes and load the latest cloud version for this scenario.',
    keepAsCopyHelp: 'Keep your local conflicting work by saving it as a new scenario copy, then continue from that copy.',
    replaceCloudWithMineHelp: 'Overwrite the cloud version of this scenario with your current local changes.',
    conflictResolvedWithLatest: 'Loaded the latest cloud version.',
    conflictSavedAsCopy: 'Saved your local work as "{name}".',
    conflictResolveError: 'Unable to load the latest version.',
    conflictCopyError: 'Unable to save the conflicting work as a copy.',
    conflictOverwriteSuccess: 'Replaced the cloud version with your local changes.',
    conflictOverwriteError: 'Unable to replace the cloud version with your local changes.',
    logout: 'Logout',
  },
  presence: {
    editingBadge: 'Editing lock',
    readOnlyBadge: 'Read-only',
    availableBadge: 'Available',
    editingTitle: 'You are editing this scenario',
    readOnlyTitle: 'This scenario is locked for editing',
    availableTitle: 'No active editor right now',
    requestPendingTitle: 'Access request sent',
    requestDeniedTitle: 'Access request denied',
    editingMessage: 'Your changes can be saved normally from this device.',
    availableMessage: 'No active editor is holding this scenario. Claim editing when you are ready to make changes.',
    requestDeniedMessage: 'Your access request was denied. You can ask again if you still need to edit this scenario.',
    readOnlyMessage: '{name} is currently editing this scenario. You can keep browsing, but edits are disabled here.',
    someone: 'Someone',
    noEditorMessage: 'No active editor detected right now.',
    requestPendingNote: 'Your access request is waiting for approval.',
    requestDeniedReason: 'Reason: {reason}',
    requestReceived: '{name} asked to edit this scenario.',
    claimEditing: 'Start editing',
    releaseEditing: 'Release editing',
    returnEditing: 'Return control to {{name}}',
    releasePendingButton: 'Releasing soon',
    releasePendingEditor: 'Releasing control to {{name}} as soon as sync finishes',
    releasePendingForYou: '{name} is releasing control back to you.',
    requestAccess: 'Request access',
    takeOver: 'Take over',
    approveRequest: 'Allow editing',
    denyRequest: 'Deny request',
    denyReasonTitle: 'Deny access request',
    denyReasonMessage: 'Add a short reason so the requester understands why access was denied.',
    denyReasonLabel: 'Reason',
    denyReasonPlaceholder: 'Example: I am still finishing changes in this scenario.',
    takeOverSuccess: 'Editing control transferred to this device.',
    takeOverError: 'Unable to take over this scenario right now.',
    claimEditingSuccess: 'Editing control is now active on this device.',
    claimEditingError: 'Unable to start editing right now.',
    releaseEditingSuccess: 'Editing control was released for this scenario.',
    returnEditingSuccess: 'Editing control returned to {{name}}.',
    releaseEditingSyncError: 'Please wait for your latest scenario changes to finish syncing before releasing editing.',
    releaseEditingError: 'Unable to release editing right now.',
    requestSent: 'Access request sent.',
    requestError: 'Unable to request access right now.',
    requestApproved: 'Editing access granted.',
    requestApproveSyncError: 'Please wait for your latest scenario changes to finish syncing before granting access.',
    requestApproveError: 'Unable to approve the access request.',
    requestDenied: 'Access request denied.',
    requestDenyError: 'Unable to deny the access request.',
    lockLost: 'This device no longer has editing access for the current scenario. The scenario is now read-only until you regain control.',
    tableReadonly: 'This scenario is currently read-only on this device. You can review the table, but changes are disabled until you get editing access.',
  },
  session: {
    warningTitle: 'Session expiring soon',
    warningBody: 'You have less than 3 minutes before your online session expires.',
    staySignedIn: 'Stay signed in',
  },
  toolbar: {
    stop: 'Stop',
    history: 'History',
    tools: 'Tools',
    appearance: 'Appearance',
  },
  indicators: {
    deleteMode: 'Delete mode active - clicking will remove tables or walls',
    wallMode: 'Wall mode active - click and drag to draw walls',
  },
};
